import md5 from 'md5';
import getUniqueItemId from './getUniqueItemId';

const sanitiseModifiers = (modifiers = []) =>
  (modifiers || [])
    .map(({ modifierId, modifierItems }) => {
      // Forces modifierItems to an array even when a single item is provided (radio option).
      const asArray = typeof modifierItems === 'string' ? [modifierItems] : modifierItems || [];
      const items = asArray
        .filter((item) => item)
        .map((item) => {
          // Object-form items carry quantity and/or nested modifiers. Only recurse when
          // nested modifiers are present so leaf objects aren't given an empty modifiers array.
          if (item && typeof item === 'object') {
            return item.modifiers
              ? { ...item, modifiers: sanitiseModifiers(item.modifiers) }
              : item;
          }
          return item;
        });

      return { modifierId, modifierItems: items };
    })
    // Removes modifiers with no remaining selection.
    .filter((modifier) => modifier && modifier.modifierItems.length > 0);

// TODO update backend to be able to collate quantities in BE
const getAddToCartPayload = (cart, newItem, newItemQuantity, childVenueId) => {
  const updatedCart = [...cart];
  const item = { ...newItem };

  const {
    modifiers,
    itemOption,
    priority,
    notes,
    isUpsell,
    upsoldFrom,
    upsoldFromItem,
    ...itemRest
  } = item;

  const sanitisedPriority = priority?.label;
  const sanitisedModifiers = sanitiseModifiers(modifiers);
  const sanitisedItemOption = itemOption.replace(/\s/g, '_').toUpperCase();
  const notesHash = notes && notes.trim() !== '' ? md5(notes) : undefined;
  const sanitizedNewItem = {
    ...itemRest,
    priority: sanitisedPriority,
    modifiers: sanitisedModifiers,
    itemOption: sanitisedItemOption,
    venueId: childVenueId,
    ...(notesHash && { notesHash }),
  };

  const newUniqItemId = getUniqueItemId(sanitizedNewItem);
  const targetItemIndex = updatedCart.findIndex(({ uniqItemId }) => uniqItemId === newUniqItemId);
  const targetItem = updatedCart[targetItemIndex];

  if (targetItem) {
    updatedCart[targetItemIndex] = {
      ...targetItem,
      quantity: targetItem.quantity + newItemQuantity,
    };

    return updatedCart;
  }

  const newItemPayload = {
    quantity: newItemQuantity,
    uniqItemId: newUniqItemId,
    priority: sanitisedPriority,
    notes,
  };

  if (isUpsell) {
    newItemPayload.isUpsell = isUpsell;
    newItemPayload.upsoldFrom = upsoldFrom;
    newItemPayload.upsoldFromItem = upsoldFromItem;
  }

  return [...cart, newItemPayload];
};

export default getAddToCartPayload;
